module.exports = __webpack_public_path__ + "img/guangzhou_ranminzhonglu.69602d17.png";